export default {
    url: '/add',
    template: '<manage-permissions-sites-add tree="vm.tree" site="vm.site"/>',
    resolve: {
        tree (SiteResource) {
            return SiteResource.indexTree().$promise;
        }
    },
    controller (tree, SiteResource) {
        this.tree = tree;
        this.site = new SiteResource();
        this.site.isActive = true;
        this.site.isExternalSite = false;
    }
};



// WEBPACK FOOTER //
// ./src/app/states/authorized/manage/permissions/sites/add/index.js